<div class="register__content">
  <div
    class="register__content-header d-flex flex-row flex-wrap justify-content-lg-between"
  >
    <div class="content__title-wrapper order-lg-1 w-100 u-width-auto@lg-min">
      <p class="content__sub-title uppercase-m semibold">
        {{ 'general.step' | translate }} {{ stepIndex() + 1 }}
      </p>

      <h2 class="mb-0 title-xl">
        {{ steps()[stepIndex()].nameNice | translate }}
      </h2>
    </div>
  </div>
  @if (customQuestions()?.length > 0) {
    <app-custom-questions-form
      [formControl]="customQuestionResponsesControl"
      [customQuestions]="customQuestions()"
      (validityChange)="onFormValidityChange($event)"
    ></app-custom-questions-form>
  }
  @if (showHierarchicalRootQuestions()) {
    <app-hierarchical-root-question-form
      [formControl]="hierarchicalRootQuestionsControl"
      [hierarchicalRootQuestions]="rootQuestions()"
      (validityChange)="onHierarchicalFormValidityChange($event)"
    ></app-hierarchical-root-question-form>
  }
  @if (
    showErrorMessage() &&
    (customQuestionResponsesControl.errors ||
      hierarchicalRootQuestionsControl.errors)
  ) {
    <div class="global-custom-questions__error">
      {{ 'forms.errors.field_required' | translate }}
    </div>
  }
</div>
